import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;

export const BodyContent = styled.div`
  padding-top: 64px;
  padding-left: 50px;
  padding-right: 50px;
  max-width: 1280px;
  display: grid;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  gap: 5%;
  grid-template-columns: 60% 35%;
  @media screen and (max-width: 1100px) {
    grid-template-columns: 50% 50%;
  }
  @media screen and (max-width: 959px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    grid-template-columns: 100%;
  }
  @media screen and (max-width: 550px) {
    width: 80%;
  }
`;

export const TextContent = styled.div`
  h5 {
    font-size: 19px;
    line-height: 23px;
    @media screen and (max-width: 959px) {
      font-size: 16px;
      text-align: center;
      padding-bottom: 16px;
    }
  }

  small {
    font-size: 13px;
    @media screen and (max-width: 959px) {
      text-align: center;
      display: flex;
    }
  }
`;

export const InputCode = styled.div`
  display: grid;
  gap: 16px;
  padding-top: 32px;
  margin-bottom: 146px;
`;
